import {printoutPalette} from "../../core/printoutPalette";

export const writingAreaBlockSx = {
    "& .printout-writing-area-block, & .printout-rendered-writing-area": {
        boxSizing: "border-box",
        display: "flex",
        flexDirection: "column",
        gap: "2.5mm",
        minWidth: 0,
        width: "100%",
        "@media print": {
            breakInside: "avoid",
            pageBreakInside: "avoid",
        },
    },
    "& .printout-writing-area-label, & .printout-rendered-writing-area-label": {
        color: printoutPalette.primaryText,
        fontSize: 12,
        fontWeight: 600,
        lineHeight: 1.35,
        minHeight: 16,
    },
    "& .printout-writing-area-surface, & .printout-rendered-writing-area-surface": {
        boxSizing: "border-box",
        height: "var(--printout-writing-area-height, 35mm)",
        minWidth: 0,
        printColorAdjust: "exact",
        WebkitPrintColorAdjust: "exact",
        width: "100%",
    },
    '& .printout-writing-area-block[data-printout-writing-area-style="ruled"] .printout-writing-area-surface, & .printout-rendered-writing-area[data-printout-writing-area-style="ruled"] .printout-rendered-writing-area-surface': {
        backgroundImage: `repeating-linear-gradient(to bottom, transparent 0, transparent calc(8mm - 1px), ${printoutPalette.subtleBorder} calc(8mm - 1px), ${printoutPalette.subtleBorder} 8mm)`,
    },
    '& .printout-writing-area-block[data-printout-writing-area-style="boxed"] .printout-writing-area-surface, & .printout-rendered-writing-area[data-printout-writing-area-style="boxed"] .printout-rendered-writing-area-surface': {
        border: `1px solid ${printoutPalette.subtleBorder}`,
    },
};
